import { useCallback } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

import { QuoteEditPage } from '#/pages/quotes'
import { useEscapeClose } from '#/shared/lib/hooks'

export const Route = createFileRoute('/_shell/quotes/$quoteId/edit')({
  component: SubRoute,
})

function SubRoute() {
  const { quoteId } = Route.useParams()
  const navigate = useNavigate()
  const listSearch = useSearch({ strict: false })
  const handleClose = useCallback(() => {
    void navigate({ to: '/quotes/$quoteId', params: { quoteId }, search: listSearch as never })
  }, [navigate, listSearch, quoteId])
  useEscapeClose(handleClose)
  return <QuoteEditPage shipmentId={quoteId} onClose={handleClose} />
}
